import { render, staticRenderFns } from "./BnHibajelentes.vue?vue&type=template&id=8b5dad00&scoped=true&"
import script from "./BnHibajelentes.vue?vue&type=script&lang=js&"
export * from "./BnHibajelentes.vue?vue&type=script&lang=js&"
import style0 from "./BnHibajelentes.vue?vue&type=style&index=0&id=8b5dad00&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b5dad00",
  null
  
)

export default component.exports